import { ServicesContainer } from '@/services';
import { NutritionCalculatorAddToBagEvent } from '@/services/analytics/events/';
import { AnalyticsEventType, Commerce } from '@/services/analytics/platforms/adobe-analytics/models';
import { AppState } from '@/store';
import { Store } from 'vuex';
import { AdobeCartAddEvent } from './adobe-cart-add';

export class AdobeNutritionCalculatorCartAddEvent extends AdobeCartAddEvent {
  event = AnalyticsEventType.AddToBag;
  commerce = {
    ... this.commerce,
    upsells: { value: 1 },
    nutritionCalculatorCartAdds: { value: 1 }
  } as Commerce;
  nutritionData = {};
  _nutritionVars = {};
  
  constructor(event: NutritionCalculatorAddToBagEvent, store: Store<AppState>, services: ServicesContainer) {
    super(event, store, services);

    this.nutritionData = event.nutrition?.tcal + '|' + event.nutrition?.tfat + '|' + event.nutrition?.prot + '|' + event.nutrition?.carb;
    this._nutritionVars = {
      calories: event.nutrition?.tcal,
      fat: event.nutrition?.tfat,
      protein: event.nutrition?.prot,
      carbs: event.nutrition?.carb
    }
  }
}
